import React, { useState, useRef, useEffect } from "react";
import RichText from "utils/RichText";

const BigTypeScrolling = ({ blok }) => {
  const containerRef = useRef();

  const [progress, setProgress] = useState(0);
  const [scrollTop, setScrollTop] = useState(0);

  useEffect(() => {
    let currentPosition = window.pageYOffset;
    const { height } = containerRef.current.getBoundingClientRect();
    function onScroll() {
      currentPosition = window.pageYOffset;
      if (currentPosition < height + 1000) {
        setProgress(currentPosition);
      }
      setScrollTop(currentPosition <= 0 ? 0 : currentPosition);
    }

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollTop]);

  return (
    <div className="my-12 overflow-hidden lg:my-24">
      <div className="mx-auto px-6 lg:px-12" ref={containerRef}>
        {/* Split RichText from Paragraphs */}

        {/* Static */}
        {blok.static_title &&
          blok.static_title.content.map((items, index) =>
            items.content.map((item) => (
              <div className="flex">
                <h1
                  className={`relative ${
                    index % 2 == 0 ? "mr-auto " : "ml-auto "
                  }  font-poppins text-primary font-display !mb-6 !text-[80px] leading-none tracking-normal lg:!text-[13vw] `}
                >
                  <RichText>{item.text}</RichText>
                </h1>
              </div>
            ))
          )}
        {/* Animated  */}
        {blok.title &&
          blok.title.content.map((items, index) =>
            items.content.map((item) => (
              <div className="flex">
                <h1
                  style={
                    index % 2 == 0
                      ? { transform: `translateX(${progress / 10}%)` }
                      : { transform: `translateX(-${progress / 10}%)` }
                  }
                  className={`relative ${
                    index % 2 == 0
                      ? "left-[-50%] mr-auto"
                      : "right-[-50%]  ml-auto"
                  } tranisition  font-poppins text-primary font-display !mb-6 flex-none !text-[80px] leading-none tracking-normal lg:!text-[13vw] `}
                >
                  <RichText>{item.text}</RichText>
                </h1>
              </div>
            ))
          )}
      </div>
    </div>
  );
};

export default BigTypeScrolling;
